import React from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { WhoIsThisFor } from './components/WhoIsThisFor';
import { TheSystem } from './components/TheSystem';
import { Content } from './components/Content';
import { Bonuses } from './components/Bonuses';
import { Comparison } from './components/Comparison';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotification } from './components/PurchaseNotification';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <main className="min-h-screen bg-charcoal font-sans selection:bg-terracotta selection:text-cream overflow-x-hidden" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Hero data-id="element-2" />
      <Testimonials data-id="element-3" />
      <PainPoints data-id="element-4" />
      <WhoIsThisFor data-id="element-5" />
      <TheSystem data-id="element-6" />
      <Content data-id="element-7" />
      <Bonuses data-id="element-8" />
      <Comparison data-id="element-9" />
      <FinalCTA data-id="element-10" />
      <Footer data-id="element-11" />
      <PurchaseNotification data-id="element-12" />
    </main>;
}